import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import SiteHeader from "./components/site/SiteHeader";
import SiteFooter from "./components/site/SiteFooter";
import HomePage from "./components/site/HomePage";
import FloatingInstagram from "./components/site/FloatingInstagram";
import StickyMobileCTA from "./components/site/StickyMobileCTA";
import AgentLogin from "./pages/AgentLogin";
import AgentDashboard from "./pages/AgentDashboard";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ServiceDetail from "./pages/ServiceDetail";
import { AuthProvider } from "./lib/auth";

function MarketingShell({ children }) {
  return (
    <>
      <SiteHeader />
      <main className="pt-[164px]">{children}</main>
      <SiteFooter />
      <FloatingInstagram />
      <StickyMobileCTA />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MarketingShell><HomePage /></MarketingShell>} />
            <Route path="/auto-insurance" element={<MarketingShell><ServiceDetail slugOverride="auto" /></MarketingShell>} />
            <Route path="/homeowners-insurance" element={<MarketingShell><ServiceDetail slugOverride="home" /></MarketingShell>} />
            <Route path="/life-insurance" element={<MarketingShell><ServiceDetail slugOverride="life" /></MarketingShell>} />
            <Route path="/health-insurance" element={<MarketingShell><ServiceDetail slugOverride="health" /></MarketingShell>} />
            <Route path="/business-insurance" element={<MarketingShell><ServiceDetail slugOverride="business" /></MarketingShell>} />
            <Route path="/specialty-insurance" element={<MarketingShell><ServiceDetail slugOverride="specialty" /></MarketingShell>} />
            <Route path="/motorcycle-insurance" element={<MarketingShell><ServiceDetail slugOverride="motorcycle" /></MarketingShell>} />
            <Route path="/rv-insurance" element={<MarketingShell><ServiceDetail slugOverride="rv" /></MarketingShell>} />
            <Route path="/watercraft-insurance" element={<MarketingShell><ServiceDetail slugOverride="watercraft" /></MarketingShell>} />
            <Route path="/jewelry-fine-art-insurance" element={<MarketingShell><ServiceDetail slugOverride="jewelry" /></MarketingShell>} />
            <Route path="/privacy" element={<MarketingShell><Privacy /></MarketingShell>} />
            <Route path="/terms" element={<MarketingShell><Terms /></MarketingShell>} />
            <Route path="/agent/login" element={<AgentLogin />} />
            <Route path="/agent" element={<AgentDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
